var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#474747",
    d: "M17.258 3.045s1.619-.63 1.484.902c-.045.631-.45 2.84-.765 5.23l-1.079 7.08s-.09 1.037-.9 1.217c-.808.18-2.023-.631-2.247-.812-.18-.135-3.373-2.164-4.497-3.156-.315-.27-.675-.812.045-1.443l4.721-4.509c.54-.54 1.08-1.803-1.169-.27l-6.296 4.283s-.719.451-2.068.045l-2.923-.901s-1.08-.677.764-1.353c4.497-2.12 10.029-4.284 14.93-6.313"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/supportIcon.0abecad3871a1a929b2fe0876af749a2.svg";
export { ForwardRef as ReactComponent };